import { configureStore } from "@reduxjs/toolkit";
import studentHomeScreenReducer from "../components/Screens/StudentHomeScreen/state/StudentHomeScreenState";
import bookScreenReducer from "../components/Screens/BookScreen/state/BookScreenState";
import currentUserReducer from "./currentuser/currentUserReducer";
import informationModalReducer from "../components/Modals/InformationModalReducer";
import readleeReducer from "./readlee/readleeReducer";
import teacherDataReducer from "./teacherData/teacherDataReducer";
import { PayloadAction } from "@reduxjs/toolkit";

const store = configureStore({
  reducer: {
    currentUserState: currentUserReducer,
    studentHomeScreenState: studentHomeScreenReducer,
    bookScreenState: bookScreenReducer,
    informationModalState: informationModalReducer,
    readleeSettingsState: readleeReducer,
    teacherState: teacherDataReducer,
  },
  // Enable this if you need to debug redux calls.  This will
  // enable tracing in the chrome redux tools
  devTools: {
    trace: true,
  },
});

const dispatch = (action: PayloadAction<unknown>) => {
  store.dispatch(action);
};

export { store, dispatch };

export type Store = typeof store;
export type RootState = ReturnType<typeof store.getState>;
